// extracted by mini-css-extract-plugin
export default {"policy_block":"TermsAndConditions_policy_block__zYfIr"};